import React, { Component } from 'react'
import { Table, TableProps } from './Table'
import { Box, TableCell, TableCellProps, TableRow, TableRowProps } from '@mui/material'
import Text from './styled/Text'
import { TableRowData } from '../../common/types'
export interface CommonTableProps extends TableProps {
    noDataMessage?: string
    rowProps?: TableRowProps
    valueCellProps?: TableCellProps
    rows: TableRowData[]
}
export default class CommonTable extends Component<CommonTableProps> {

    render() {
        const { rowProps = { }, valueCellProps = { }, rows, noDataMessage, ...restProps } = this.props
        return (
            <Table
            {...restProps}
            >
                {!rows?.length && noDataMessage && 
                    <TableCell sx={{ textAlign: 'center' }} colSpan={restProps.headerColumns?.length}><Text>{noDataMessage}</Text></TableCell>
                }
                {rows.map(({ key, title, titleSx = {}, valueSx = {}, titleRowSpan, values, rowProp, valueKeys, ignoreTitle, seperator }) => {
                    const shouldIncludeTitle = !ignoreTitle && title;
                    if (seperator) {
                        return (
                            <TableRow key={key || title} {...rowProps} {...(rowProp ?? {})}>
                                <TableCell sx={{ borderBottom: '1px solid #000', borderTop: '1px solid #000', height: '2.5rem' }} colSpan={restProps.headerColumns?.length}></TableCell>
                            </TableRow>
                        )
                    }

                    return (
                        <TableRow key={key || title} {...rowProps} {...(rowProp ?? {})}>
                            {shouldIncludeTitle && <Box component={TableCell} rowSpan={titleRowSpan} sx={{ ...titleSx }}><Text sx={{ ...titleSx }}>{title}</Text></Box>}
                            {values.map((value: any, index: number) => {
                                const cellKey = valueKeys ? valueKeys[index] : `${index}${value}`;

                                return <TableCell key={cellKey} {...valueCellProps}><Text sx={{ ...valueSx }}>{value}</Text></TableCell>
                            })}
                        </TableRow>
                    )
                })}
            </Table>
        )
    }

}